export default "__VITE_PUBLIC_ASSET__8967f9d8__"